// extracted by mini-css-extract-plugin
export default {"count":"Ceiww","text":"RjSja","icon":"GQQoA"};